import React, {useEffect, useState} from 'react';
import FiltersComponent from '../components/filters/FiltersComponent'
import AdResultGrid from "../components/search/AdResultGrid";
import {Box, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DetailsView from "./ViewAdDetails";
import CategoryDialog from "../components/dialogs/CategoryDialog";
import ShowContentForUser from "../components/modalwindow/ShowContentForUser";
import OffersViewContainerGrid from "../components/Offers/OffersViewContainerGrid";


// Importar servicios y constantes para guardar el anuncio
import RequestSvc from "../services/RequestSvc";
import {API} from "../utils/Constants";
import {fetchCategories} from "../api/api";

const modalContent = (
    <iframe
        width="600"
        height="440"
        src="https://www.youtube.com/embed/w8mcNXTOCos?si=e-yClmP6KO6oSsbq"
             
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
    ></iframe>
);
const SearchView = ({
    isSidebarOpen,
    setSidebarOpen,
    setNewRow,
    selectedOfferSubitem // <-- Add this prop
}) => {
    const [showModal, setShowModal] = useState(true);
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const [showContainerNoMoreData, setShowContainerNoMoreData] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [queryString, setQueryString] = useState("");
    const [searchTerms, setSearchTerms] = useState("");

    // Estados para la tarjeta de detalles
    const [showDetails, setShowDetails] = useState(false);
    const [itemSelectedDetail, setItemSelectedDetail] = useState({});

    // Estados para el diálogo de categoría (OPCIÓN 1)
    const [showCategoryDialog, setShowCategoryDialog] = useState(false);
    const [selectedAd, setSelectedAd] = useState({});
    const [categories, setCategories] = useState([]);
    const [categorySelected, setCategorySelected] = useState(null);
    const [numberDuplicates, setNumberDuplicates] = useState(1);

    /* INIT EVENTS  */

    /**
     * Handler for when the user clicks the Search button in the Filters component
     * No eliminar el setTimeout. Esto asegura reinicar la grilla y valores
     * cuando se hace una nueva busqueda.
     * @param filters
     * @return {Promise<void>}
     */
    const handleSearch = async (filters) => {
        setHasSearched(false)
        setShowDetails(false)
        setShowContainerNoMoreData(false)
        setTimeout(() => {
            setQueryString(filters);
            setHasSearched(true);
            const search = new URLSearchParams(filters);
            setSearchTerms(search.get("search_terms") ?? "")
        }, 50)
    };

    // Función para lanzar el diálogo de categoría
    const launchCategoryDialog = (item) => {
        fetchAdDetails(item);
        setShowCategoryDialog(true);
    };

    /**
     * Función para cerrar el diálogo
     */
    const closeCategoryDialog = () => {
        setShowCategoryDialog(false);
    };

    /**
     * Función para seleccionar una categoría (se la pasamos al diálogo)
     * @param catSelected
     */
    const onSelectCategory = (catSelected) => {
        setCategorySelected(catSelected);
    };

    /**
     * Función para enviar (submit) el anuncio con la categoría seleccionada
     */
    const submitSaveAd = () => {
        setShowCategoryDialog(false);
        const updatedAd = {...selectedAd, FK_Category_Code: categorySelected};
        saveAd(updatedAd);
    };

    /*  END EVENTS  */


    /*  INIT METHODS    */

    /**
     * Función para guardar el anuncio (se podría mejorar con manejo de errores)
     * @param adObject
     * @returns {Promise<void>}
     */
    const saveAd = async (adObject) => {
        let request = new RequestSvc();
        await request.post(API.AD, adObject);
    };

    /**
     * Cargar las categorías del usuario (se llama una única vez)
     * @returns {Promise<void>}
     */
    const loadUserCategories = async () => {
        try {
            let results = await fetchCategories();
            setCategories(results);
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * Obtener los detalles
     * @param item
     * @returns {Promise<void>}
     */
    const fetchAdDetails = async (item) => {
        try {
            const response = await fetch(`https://test.tueducaciondigital.site/getdetailscardview?LibraryID=${item.LibraryID}`);
            const result = await response.json();

            if (result.error || !result.data || result.data.length === 0) {
                throw new Error("No se encontraron detalles para el anuncio");
            } else {
                console.log("Ad details fetched:", result.data[0]);
                setSelectedAd(result.data[0]);

            }
        } catch (err) {
            console.error("Error fetching ad details:", err);
        }
    };

    /*  END METHODS */

    useEffect(() => {
        loadUserCategories();
    }, []);

    useEffect(() => {
        if (showDetails && isSidebarOpen) {
            setShowDetails(false);
        }
    }, [isSidebarOpen]);

    return (
        <div style={{display: "flex"}}>
            <div className={"search-view-container-filters-grid"}>
                   {!selectedOfferSubitem && (
                        <FiltersComponent setFilterData={handleSearch} setNumberDuplicates={setNumberDuplicates}/>
                    )}
                    {showModal &&
                        <ShowContentForUser onClose={handleCloseModal} myIframe={modalContent} width={640} height={480}/>}
                    <div className={"search-view-container-grid"}>
                        {selectedOfferSubitem ? (
                            <OffersViewContainerGrid nichoCode={selectedOfferSubitem}>
                                <h2 className="nicho-title">Nicho de {selectedOfferSubitem}</h2>
                            </OffersViewContainerGrid>
                        ) : !hasSearched ? (
                            <Box sx={{m: 2, borderColor: "#f2f2f2", p: 2, textAlign: "center"}}>
                                < Typography variant="h6" color="textSecondary">
                                    Por favor, ajusta los filtros y presiona "Buscar" para ver los resultados.
                                </Typography>
                            </Box>
                        ) : (
                            <AdResultGrid queryString={queryString}
                                        setShowDetails={setShowDetails}
                                        showDetails={showDetails}
                                        setItemSelectedDetail={setItemSelectedDetail}
                                        setSidebarOpen={setSidebarOpen}
                                        setShowContainerNoMoreData={setShowContainerNoMoreData}
                                        numberDuplicates={numberDuplicates}
                                        setNewRow={setNewRow}/>
                        )}
                    {
                        showContainerNoMoreData && (
                            <div className={"search-container-no-more-data"}>
                                <Typography color="textSecondary" variant="h6">No encontro resultados
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            fontStyle: "italic",
                                            color: "green"
                                        }}
                                    >
                                    </span>
                                </Typography>
                            </div>
                        )
                    }
                </div>
            </div>
            {showDetails && (
                <div className={'detail-sticky'} style={{marginTop: "160px"}}>
                    <div className={'grid-details-close-layout'}>
                        <CloseIcon className={'grid-details-close-btn'}
                                   onClick={(e) => setShowDetails(false)}
                                   sx={{
                                       width: '38px',
                                       height: '38px',
                                       color: 'white',
                                       padding: '4px',
                                       borderRadius: '50%',
                                       borderWidth: '0.5px',
                                       borderStyle: 'solid',
                                       borderColor: 'rgba(255,255,255,0.18)'
                                   }}
                        />
                    </div>
                    <div className={'grid-details-main'}>
                        <div className={'grid-details'}>
                            <DetailsView
                                item={itemSelectedDetail}
                                launchCategoryDialog={launchCategoryDialog}
                            />
                        </div>
                    </div>
                </div>
            )}
            {showCategoryDialog && (
                <CategoryDialog
                    rows={categories}
                    open={showCategoryDialog}
                    closeCategoryDialog={closeCategoryDialog}
                    onSelectCategory={onSelectCategory}
                    submitSaveAd={submitSaveAd}
                />
            )}
        </div>
    );
};

export default SearchView


